export default "__VITE_ASSET__Dmnw6UTP__"